import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-checkbox-item',
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <div class="checkbox-item" [ngClass]="{ disabled: this.disabled }" (click)="onCheckItem()">
      <div class="checkbox">
        <yalo-checkbox [value]="checked"
                       [indeterminate]="indeterminate">
        </yalo-checkbox>
      </div>
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      .checkbox-item {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        cursor: pointer;
      }

      .disabled {
        opacity: 0.5;
        pointer-events: none;
      }

      .checkbox {
        display: grid;
        place-items: center;
        width: 2.5rem;
        height: 2.5rem;
      }

      yalo-checkbox {
        background: #ffffff;
        pointer-events: none;
      }
    `,
  ],
})
export class CheckboxItemComponent {
  @Input() checked = false;
  @Input() indeterminate = false;
  @Input() disabled = false;
  @Output() checkedChange = new EventEmitter<boolean>();

  onCheckItem() {
    if (!this.disabled) {
      this.checked = !this.checked;
      this.checkedChange.emit(this.checked);
    }
  }
}
